import React from "react";
import useConfirm from "./useConfirm";
import {useTheme} from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import {DialogContent, Typography} from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Icon from "@material-ui/core/Icon";
import {uid} from "react-uid";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../lib";

const ConfirmDialog = () => {
    const {onConfirm, onCancel, confirmState} = useConfirm();
    const userLanguage = useSelector(state => state.app.userLanguage);
    const {
        show, buttons = [], cancelLabel,
        submitLabel, type, text,
        title, clickedCallback, width
    } = confirmState;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const multiLanguageButtons = multiLanguageValue(buttons, userLanguage) || [];
    return (
        <Dialog
            open={show}
            fullScreen={fullScreen}
            onClose={onCancel}
            fullWidth={true}
            maxWidth={width}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="form-dialog-title"
                style={{
                    padding: '8px 24px',
                    fontSize: '1.15rem'
                }}
            >
                {title ? multiLanguageValue(title, userLanguage) : 'Confirmation'}
            </DialogTitle>

            <DialogContent>
                <div style={{display: "flex", alignItems: 'center'}}>
                    <IconByType type={type}/>
                    <DialogContentText style={{marginBottom: 0}}>
                        <Typography style={{
                            whiteSpace: 'pre-wrap',
                        }}>{text ? multiLanguageValue(text, userLanguage) : "Are you sure?"}</Typography>
                    </DialogContentText>
                </div>

            </DialogContent>
            <DialogActions>
                {multiLanguageButtons.length ? (
                    multiLanguageButtons.map((btn, index) => (
                        <Button
                            key={uid(btn)}
                            onClick={() => {
                                clickedCallback(index + 1);
                                onConfirm()
                            }}
                            variant={"outlined"}
                            color="primary" //autoFocus={index === 0}
                        >
                            {btn}
                        </Button>
                    ))
                ) : (
                    <>
                        <Button
                            id="deleteBtn"
                            onClick={() => {
                                onConfirm();
                                onCancel()
                            }}
                            color="primary"
                           // autoFocus
                        >
                            {submitLabel ? submitLabel : 'Submit'}
                        </Button>
                        <Button
                            id="closeBtn"
                            onClick={onCancel}
                            color="primary"
                        >
                            {cancelLabel ? cancelLabel : 'Cancel'}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}
export default ConfirmDialog;


const IconByType = ({type}) => {
    const commonStyles = {
        fontSize: 30, margin: '10px 10px 10px 0'
    };
    switch (type) {
        case 'success':
            return <Icon style={{...commonStyles, color: '#388e3c'}}>check_circle</Icon>;
        case 'warning':
            return <Icon style={{...commonStyles, color: '#ff9800'}}>warning_amber</Icon>;
        case 'error':
            return <Icon style={{...commonStyles, color: '#d50000'}}>clear</Icon>;
        case 'info':
            return <Icon style={{...commonStyles, color: '#1565c0'}}>info</Icon>;
        default:
            return <Icon style={{...commonStyles, color: '#1565c0'}}>info</Icon>
    }
};